export default __webpack_public_path__ + "static/property01-2bd3a5c618eee9559b08e2a27339ab25.png";